import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { EventType } from '@models/ops-event/event-type';
import { Store } from '@ngxs/store';
import { OpsEventTypesState } from '@store/ops-event/ops-event-types.state';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter, switchMap } from 'rxjs/operators';

@Component({
  selector: 'event-i18n-event-type',
  templateUrl: './i18n-event-type.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class I18nEventTypeComponent implements OnInit {
  model$ = new BehaviorSubject<string | undefined>(undefined);
  eventType$: Observable<EventType>;

  @Input()
  set model(model: string) {
    this.model$.next(model);
  }

  constructor(private readonly store: Store) {}

  ngOnInit(): void {
    this.eventType$ = this.model$.pipe(
      filter((model) => !!model),
      switchMap((model) => this.store.select<EventType>(OpsEventTypesState.eventType(model)))
    );
  }
}
